import React, { useState, useEffect } from 'react';
import { TextField } from "@material-ui/core";
import { FormControlLabel, FormGroup } from "@material-ui/core";
import Checkbox from '@material-ui/core/Checkbox';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import '../../../styles/squarefooter.scss';

export default function Built(props) {
	const [numberValidation, setNumberValidation] = useState(false)
	const [resetValue, setResetValue] = useState(true)
	const [display, setDisplay] = React.useState(false)
	const [garage_parking_count, setGarageParking] = useState(0);
	const [built, setBuilt] = useState('')
	const handleBuilt = (e) => {
		setBuilt(e.target.value)
		props.values.property_build_year = e.target.value;
	}

	useEffect(()=>{
		if(props?.partner?.url_path === "c2"){
			const h2Tags = document.querySelectorAll('h2');
			const h4Tags = document.querySelectorAll('h4');
			const h6Tags = document.querySelectorAll('h6');
			const spanTags = document.querySelectorAll('span');
			const a = document.querySelectorAll('a');
			  h2Tags.forEach(h2 => {
				h2.classList.add('ftpolar-semibold');
			  });
			  h4Tags.forEach(h4 => {
				h4.classList.add('ftpolar-semibold');
			  });
			  h6Tags.forEach(h6 => {
				h6.classList.add('ftpolar-semibold');
			  });
			  spanTags.forEach(span => {
				span.classList.add('ftpolar-light');
			  });
			  a.forEach(a => {
				a.classList.add('ftpolar-light');
			  });
		}
		},[props.submitResponse])

	const [sqft, setSqft] = useState(null)
	const handleGrade = (e) => {
		setSqft(e.target.value)
		e.preventDefault()
		props.values.property_in_sqft = e.target.value;
	}
	const [condoUnitNum, setCondoUnitNum] = useState(null)
	const handleCondoUnitNum = (e) => {
		setCondoUnitNum(e.target.value)
		e.preventDefault()
		props.values.condo_unit_number = e.target.value;
	}
	const [condoAssocName, setCondoAssocName] = useState(null)
	const handleCondoAssocName = (e) => {
		setCondoAssocName(e.target.value)
		e.preventDefault()
		props.values.condo_association_name = e.target.value;
	}
	const resetInputField = () => {
		setResetValue(props.values.garage_parking_count = 0);
		props.values.garage_parking_count = 0
		setGarageParking(0)
	};


	useEffect(()=>{
	if(props?.partner?.url_path === "c2"){
        const h2Tags = document.querySelectorAll('h2');
        const h4Tags = document.querySelectorAll('h4');
        const h6Tags = document.querySelectorAll('h6');
        const spanTags = document.querySelectorAll('span');
        const a = document.querySelectorAll('a');
          h2Tags.forEach(h2 => {
            h2.classList.add('ftpolar-semibold');
          });
          h4Tags.forEach(h4 => {
            h4.classList.add('ftpolar-semibold');
          });
          h6Tags.forEach(h6 => {
            h6.classList.add('ftpolar-semibold');
          });
          spanTags.forEach(span => {
            span.classList.add('ftpolar-light');
          });
          a.forEach(a => {
            a.classList.add('ftpolar-light');
          });
	}
    },[props.pageNumber,props.submitResponse])

	useEffect(() => {
		props.handleNext("property")
	}, [])

	const restrictDecimal = (e,id) =>{
        var deleteKeyCode = 8;
        var backspaceKeyCode = 46;
        if ((e.which>=48 && e.which<=57) ||
        (e.which>=96 && e.which<=105)  ||
        e.which === deleteKeyCode ||
            e.which === backspaceKeyCode||e.which===190 || e.which===37 || e.which===39){
                var valuemortgageInfoCumulative = document.getElementById(id);
                if(valuemortgageInfoCumulative.value.indexOf('.')!==-1 && e.which===190){
                    e.preventDefault();
                }
            }else{
                e.preventDefault();
            }  
    }

	var currentTime = new Date();
	const valueUpdate = (e, value) => {
		if (e.target.id === 'garage_parking_value') {
			setGarageParking(e.target.value)
			props.values.garage_parking_count = e.target.value
		}
		if (e.target.value <= 25) {
			props.values[value] = e.target.value
			setNumberValidation(false)
		} else {
			setNumberValidation(true)
		}
	}
	let incrementfullBathroom = () => {
		let garage_parking_value = document.getElementById('garage_parking_value');
		if (Number(garage_parking_value.value) < 25) {
			garage_parking_value.value = Number(garage_parking_value.value) + 1
			setGarageParking(garage_parking_value.value === "" ? 1 : Number(garage_parking_value.value));
			props.values.garage_parking_count = garage_parking_value.value
		}
	}
	let decrementfullBathroom = () => {
		let garage_parking_value = document.getElementById('garage_parking_value');
		if (Number(garage_parking_value.value) > 0) {
			garage_parking_value.value = Number(garage_parking_value.value) - 1
			setGarageParking(garage_parking_value.value <= 0 ? 0 : Number(garage_parking_value.value));
			props.values.garage_parking_count = garage_parking_value.value
		}
	}
	const handleDisplay = () => {
		setDisplay(!display)
	}

	function ButtonIncrement(props) {
		return (
			<span className="buttonInc d-flex align-items-center justify-content-center" onClick={props.onClickFunc}>
				<span className="spanInc">+</span>
			</span >
		)
	}

	function ButtonDecrement(props) {
		return (
			<span className="buttonInc d-flex align-items-center justify-content-center" onClick={props.onClickFunc}>
				<span className="spanDec">-</span>
			</span >
		)
	}

	const handleKeyDown = e => {
		if (e.key === " " || e.key === ".") {
		  e.preventDefault();
		}
	  };

	return (
		<div className="form-question">
			<div className="form-content" id="propert_title">
				<div>
					<h2 className="form-content-heading m-0">
						Can you give us some other property details?
					</h2>
					<div className="pt-2 form-content-field">
						<div className="py-2">
						{props?.formik?.values?.property_type_id === "3"?
						<>
							<div className="w-res-50 py-2">
								<div className="pb-2">
									<h6 className="m-0">What is your property unit number?</h6>
								</div>
								<div>
									<TextField
										type="text"
										variant="outlined"
										name="condo_unit_number"
										placeholder=''
										id="condo_unit_number"
										onChange={handleCondoUnitNum}
										onBlur={props.handleChange}
										value={props.values.condo_unit_number}
										inputProps={{ maxLength: 10 }}
										style={{width: '256px'}}
									/>
								</div>
							</div>
							<div className="w-res-50 py-2">
								<div className="pb-2">
									<h6 className="m-0">What is your Condo Assoc. Name?</h6>
								</div>
								<div>
									<TextField
										type="text"
										variant="outlined"
										name="condo_association_name"
										placeholder=''
										id="condo_association_name"
										onChange={handleCondoAssocName}
										onBlur={props.handleChange}
										value={props.values.condo_association_name}
										style={{width: '256px'}}
										multiline
										rows={4}
									/>
								</div>
							</div></>
							:<></>}	
							<div className="w-res-50 py-2">
								<div className="pb-2">
									<h6 className="m-0">Year Built</h6>
								</div>
								<div>
									<TextField
										type="text"
										variant="outlined"
										name="property_build_year"
										placeholder='ex: 1924'
										id="property_build_year"
										onChange={handleBuilt}
										onBlur={props.handleChange}
										onKeyDown={handleKeyDown}
										value={props.values.property_build_year < currentTime.getFullYear() + 1 ? props.values.property_build_year.trimStart() : ''}
										inputprops={{
											pattern: "[0-9]{4}",
											maxlength: "4",
											min: "1800",
											max: '2100'
										}}
										style={{width: '256px'}}
									/>
								</div>
							</div>

							<div className="w-res-50 py-2">
								<div className="pb-2">
									<h6 className="m-0">Above Grade Square-footage</h6>
								</div>
								<div>
									<TextField
										type="text"
										variant="outlined"
										name="property_in_sqft"
										placeholder='ex: 2400'
										id="squareft"
										onChange={handleGrade}
										onBlur={props.handleChange}
										value={props.values.property_in_sqft}
										onKeyDown={(e) => restrictDecimal(e,"squareft")}
										style={{width: '256px'}}
									/>
								</div>
							</div>

							{/* <div className="w-res-50 py-2">
								<FormGroup row value={props.values.garage} onChange={props.handleChange}>
									<FormControlLabel
										control={<Checkbox onClick={resetInputField} checked={props.values.garage_type === true} icon={<RadioButtonUncheckedIcon />} name="garage_type" onChange={props.handleChange, () => { handleDisplay() }} checkedIcon={<CheckCircleIcon className="checkedIcon" />} />}
										label="Garage"
										value={props.values.garage_type}
									/>
								</FormGroup>
								{props.values.garage_type === true ?
									<div className="d-flex px-3 ml-4">
										<div>
											<h6 className="m-0">Parking Spaces</h6>
										</div>
										<div className="col-5 ml-5 d-flex align-items-center justify-content-around aboutIncDec">
											<ButtonDecrement onClickFunc={decrementfullBathroom} />
											<input type="number" id="garage_parking_value" min="0" max="25" onFocus={props.handleChange} onChange={(e) => valueUpdate(e, "garage_parking_count")} value={props.values.garage_parking_count ? props.values.garage_parking_count : garage_parking_count} style={{ width: '40px', borderRadius: '4px', height: '30px', border: '1px solid gray', textAlign: 'center' }} />
											<ButtonIncrement onClickFunc={incrementfullBathroom} />
										</div>
									</div>
									: null}
							</div> */}

							<div className="w-res-50 py-2">
							</div>
							{numberValidation === true ?
								<div className="pt-2 row">
									<div className="pt-2 col-md-auto">
										<p className="text-danger">
											Please provide the input from 0 to 25
										</p>
									</div>
								</div>
								: ''
							}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}